import { get } from 'lodash'

import { types } from './FoodSafety.actions'
import { INITIAL_STATE as INITIAL_STATE_FILTER } from 'constants/traceability.constants'

const INITIAL_STATE = {
  filterFoodSafety: INITIAL_STATE_FILTER,
  foodSafeties: {
    items: null,
    pagination: {}
  }
}

function setFoodSafety(state) {
  return function _handle(payload: Record<string, any>) {
    return { ...state, ...payload }
  }
}

export default function _reducer(state = INITIAL_STATE, { type, payload }) {
  const _handlers = {
    [types.SET_FOODSAFETY]: setFoodSafety(state),
    [types.SET_FILTERS_FOODSAFETY]: setFoodSafety(state),
    [types.CLEAN_FOODSAFETY]: setFoodSafety(INITIAL_STATE),
    _default: () => state
  }

  return get(_handlers, type, _handlers._default)(payload)
}
